import { render, staticRenderFns } from "./ProfileSettingsCurrentSubscriptions.vue?vue&type=template&id=005c8db2&scoped=true&"
import script from "./ProfileSettingsCurrentSubscriptions.vue?vue&type=script&lang=ts&"
export * from "./ProfileSettingsCurrentSubscriptions.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileSettingsCurrentSubscriptions.vue?vue&type=style&index=0&id=005c8db2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c8db2",
  null
  
)

export default component.exports